export const YOUTUBE_API_NOT_LOADED = 'Youtube Player API library not loaded'
export const FAILED_TO_CREATE_YOUTUBE_API_INSTANCE = 'Failed to create Youtube Player API instance'
export const LOCAL_DEVICE_INFO_NOT_FOUND = 'Local device info not found'
export const NO_SPACE_FOR_TRUNCATED_TEXT =
  'There is not enough space for truncated text. Please check a layout'
export const CLOSE_FULLSCREEN = 'Close fullscreen ERROR'
export const SYSTEM_ABORTED_UPLOAD = 'System aborted upload operation'
